import * as Sentry from '@sentry/browser';

import { Benchmarks } from '@/core';
import { benchmarksMutationTypes } from '../mutation-types';

export async function startBenchmarks({ commit, dispatch, rootState }, { activeCompany }) {
  try {
    const benchmarksInstance = new Benchmarks(rootState.user.user, activeCompany);

    const {
      hasBenchmarksExpired,
      benchmarksList,
      pageGroups,
      isValidAccessToBenchmarks,
    } = await benchmarksInstance.execute();

    if (hasBenchmarksExpired || !isValidAccessToBenchmarks) return;

    commit(benchmarksMutationTypes.ADD_BENCHMARKS_LIST, benchmarksList);
    commit(benchmarksMutationTypes.ADD_PAGE_GROUPS, pageGroups);

    await dispatch({ type: 'getChannels' });
    await dispatch({ type: 'getColorList' });
  } catch (e) {
    Sentry.captureException(e);
    console.error(e);
    throw e;
  }
}
